/* eslint-disable linebreak-style */
import React, { useState } from 'react';
import { MigrationSection } from './MigrationSection';
import { Button } from '@mui/material';

interface PreMigrationNoticeProps {
  platform: 'cdh' | 'cobra' | 'combined' | 'cdhTransition' | 'cobraTransition';
  date: { cdh: string; cobra: string; };
  cdhWaveId?: number | null;
  liveDate: { cdh: string; cobra: string; };
}

export function PreMigrationNotice({
  platform,
  date,
  liveDate,
}: Readonly<PreMigrationNoticeProps>): React.ReactElement {
  const [ isVisible, setIsVisible ] = useState(true);

  function handleToggleVisibility() {
    setIsVisible((prev) => !prev);
  }

  if (!isVisible) {
    return (
      <div style={ { display: 'flex', justifyContent: 'space-between', marginTop: '16px', width: '90%' } }>
        <Button
          type="button"
          onClick={handleToggleVisibility}
          variant="contained"
        >
        Show Notice
        </Button>
      </div>
    );
  }

  let titleText = '';
  let paragraphs = <></>;

  switch (platform) {
  case 'combined':
    paragraphs =
        (
          <>
            <p>
                We are rolling out a <strong>new Benefits Administration website</strong> for FSA, HSA, HRA,
                and Transportation plans, as well as a <strong>new COBRA and Direct Billing website</strong>, and
                your account will be transitioning soon.
            </p>

            <br />

            <p>
                Your Benefits Administration account will migrate on <strong>{date.cdh}</strong>, and your COBRA/Direct
                Billing account will migrate on <strong>{date.cobra}</strong>. These changes introduce new tools and an
                updated user experience. Until each migration occurs, continue using the current portal for processing
                and historical data.
            </p>

            <br />
          </>
        );
    titleText = 'Action Required Soon: New Benefit Account Administration & COBRA/Direct Billing Platforms';
    break;
  case 'cdh':
    titleText = 'Action Required Soon: New Benefit Account Administration Platform';
    paragraphs =
        (
          <>
            <p>
                We are rolling out a <strong>new Benefits Administration website</strong>, for FSA, HSA, HRA,
                Transportation plans, and your account will be transitioning soon.
            </p>

            <br />

            <p>
                Your account will migrate to the new platform on <strong>{date.cdh}</strong>. This change introduces new
                tools and an updated user experience. Until the migration occurs, continue using the current portal for
                processing and historical data.
            </p>

            <br />
          </>
        );
    break;
  case 'cobra':
  case 'cobraTransition':
    titleText = 'Action Required Soon: New COBRA & Direct Billing Platform';
    paragraphs =
        (
          <>
            <p>
                We are rolling out a <strong>new COBRA and Direct Billing website</strong>, and your account will be
                transitioning on <strong>{date.cobra}</strong>. This change introduces new tools and an updated user
                experience. Until the migration occurs, continue using the current portal for processing and historical
                data.
            </p>

            <br />
          </>
        );
    break;
  case 'cdhTransition':
    titleText = 'Action Required Soon: New Benefit Account Administration Platform';
    paragraphs =
          (
            <>
              <p>
                      Administrative actions are temporarily unavailable on this portal while we transition your data to
                      our new platform. If you need to urgently take action, such as edit enrollment or upload a file,
                      please contact your dedicated client service representative. You can expect registration details
                      for the new website to be shared via email in the coming days. Updates will also be posted here on
                      this site.
              </p>

              <br />

              <p>
                      We are introducing our new Benefits Administration website for FSA, HSA, HRA, and Transportation
                      plan administration. Migration is currently in progress, and your account is expected to be ready
                      for administrative access on {liveDate.cdh}.
              </p>

              <br />
            </>
          );
    break;
  default:
    break;
  }

  const title = titleText;
  const content = (
    <>
      {paragraphs}

      <p>
        Please update your safe-senders list to include
        <a style={ { color: 'blue' } } href="mailto:Alerts@floreshr.com"> Alerts@floreshr.com</a>,
        as all migration details, including <strong>important instructions, timelines, and required actions </strong>
        will be sent from this address. You will need to
        <strong> take action to maintain uninterrupted access and
          administrative capabilities.
        </strong>
      </p>

      <div style={ { display: 'flex', justifyContent: 'center', marginTop: '16px', width: '100%' } }>
        <Button
          type="button"
          onClick={handleToggleVisibility}
          variant="contained"
        >
          Dismiss
        </Button>
      </div>
    </>
  );

  return <MigrationSection body={[{ title: title, content: content, titleColor: '#F44336' }]} />;
}
